import { SelectField, TextField } from '@mi-front/ui';
import { useQuery } from '@tanstack/react-query';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../../../../../../api';
import { GipReportValues } from '../../types';
import { LoadOrderParamsFromCustomField } from './LoadOrderParamsFromCustomField';

export const CustomFields = () => {
  const { $t } = useIntl();
  const { values } = useFormikContext<GipReportValues>();
  const params = {
    stations: values.stations?.map((s) => s.id) || [],
  };
  const query = useQuery({
    queryKey: ['gip-report-CustomFields', params],

    queryFn: () =>
      apiClient.audit
        .gipFetchCustomFields(params)
        .then((values) => values.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())))
        .then((values) => values.map((name) => ({ name }))),
  });

  if (!query.data?.length) {
    return null;
  }

  return (
    <div>
      <div className="row">
        <div className="col-3">
          <SelectField
            name="customFieldKey"
            label={$t({
              id: 'audit.gipReport.form.customField',
              defaultMessage: 'Campo custom',
            })}
            placeholder={$t({
              id: 'audit.gipReport.form.selectCustom',
              defaultMessage: 'Seleccione campo custom',
            })}
            options={query.data}
            isClearable
            getOptionLabel={(value) => value.name}
            getOptionValue={(value) => value.name}
          />
        </div>
        <div className="col-3">
          <TextField
            name="customFieldValue"
            label={$t({
              id: 'audit.gipReport.form.customFieldValue',
              defaultMessage: 'Valor del campo',
            })}
          />
        </div>
      </div>
      <div style={{ marginTop: '-16px' }}>
        <LoadOrderParamsFromCustomField />
      </div>
    </div>
  );
};
